import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from 'react-helmet-async';

import "./assets/css/index.css";
import "./assets/lib/tailwind/@mdi/css/materialdesignicons.min.css";

import { FirebaseAppProvider } from "reactfire";
import { AuthProvider, FirestoreProvider } from "reactfire";
import { getAuth } from "firebase/auth";

import { firebaseConfig } from "./infrastructure/firebase/firebase.config";
import { firebaseApp, firebaseDB } from "./infrastructure/firebase/firebase";

import reportWebVitals from "./reportWebVitals";
import App from "./App";

import * as Sentry from "@sentry/react";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const environment = process.env.REACT_APP_ENVIRONMENT || "development";
const release =
  process.env.REACT_APP_SENTRY_RELEASE ||
  "omnibutler@" + process.env.npm_package_version;

if (environment !== "development") {
  Sentry.init({
    dsn: "https://f7d6d8bcb68d893f45ed1d6f3e0fe557@o4508375598825472.ingest.de.sentry.io/4508375604592720",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: environment === "production" ? 0.1 : 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    environment: environment,
    release: release,
    beforeSend(event, hint) {
      // Check if it is an exception, and if so, show the report dialog
      if (event.exception && event.event_id) {
        Sentry.showReportDialog({
          eventId: event.event_id,
          user: {
            name: hint.data?.user?.name,
            email: hint.data?.user?.email,
          },
          title: "Something went wrong",
          subtitle: "Our team has been notified",
          subtitle2:
            hint.originalException instanceof Error
              ? hint.originalException.message
              : "Help us fix this by providing additional details",
        });
      }
      return event;
    },
  });
}
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const auth = getAuth(firebaseApp);

root.render(
  <React.StrictMode>
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <AuthProvider sdk={auth}>
        <FirestoreProvider sdk={firebaseDB}>
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </FirestoreProvider>
      </AuthProvider>
    </FirebaseAppProvider>
  </React.StrictMode>,
);

serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.debug);
